"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { PublicServiceDetail } from "@/types/service";
import { EmptyServicesState } from "./empty-services-state";
import { PromotionCategoryBadge, hasPromotionServices } from "./promotion-category";
import { ServiceAccordionGroup } from "./service-accordion";
export interface SidebarCategoryAccordionGroup extends ServiceAccordionGroup {
  title: string;
  services: PublicServiceDetail[];
}
export interface SidebarCategoryAccordionProps<G extends SidebarCategoryAccordionGroup> {
  groups: G[];
  renderService: (service: G["services"][number], index: number, groupId: string, standalone: boolean) => ReactNode;
  emptyState?: ReactNode;
}
export const SidebarCategoryAccordion = t0 => {
  const $ = _c(11);
  const {
    groups,
    renderService,
    emptyState
  } = t0;
  const isEmpty = groups.length === 0 || groups.every(_temp);
  if (isEmpty) {
    let t1;
    if ($[0] !== emptyState) {
      t1 = emptyState ?? <EmptyServicesState />;
      $[0] = emptyState;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <>{t1}</>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] !== groups || $[5] !== renderService) {
    let t2;
    if ($[7] !== renderService) {
      t2 = group_0 => <AccordionItem key={group_0.id} value={group_0.id} className="overflow-hidden rounded-[0.82rem] border shadow-sm"><AccordionTrigger className="px-4 py-3 text-left rounded-t-xl gap-2 hover:no-underline data-[state=open]:border-b transition-[border-radius]"><div className="flex w-full items-center justify-between gap-3"><div className="flex items-center gap-2"><h3 className="text-body-lg text-foreground-secondary">{group_0.title}</h3>{hasPromotionServices(group_0.services) && <PromotionCategoryBadge />}</div><span className="text-body text-nowrap">{`${group_0.services.length} ${group_0.services.length === 1 ? "service" : "services"}`}</span></div></AccordionTrigger><AccordionContent className="pb-0"><div className="group/list">{group_0.services.map((service, index) => renderService(service, index, group_0.id, group_0.services.length === 1))}</div></AccordionContent></AccordionItem>;
      $[7] = renderService;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = groups.map(t2);
    $[4] = groups;
    $[5] = renderService;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <Accordion type="multiple" className="space-y-4">{t1}</Accordion>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default SidebarCategoryAccordion;
function _temp(group) {
  return group.services.length === 0;
}